<template>
  <div class="back">
	<br>
	<br>
	<div class="top">
		<p>{{timerstarttime}}</p>
	</div>
	<div class="mid">
		
		<h2>{{timerlength}}</h2>
	</div>
	<div class="bottom">
		<p>Take Break</p>
		<router-link class="blob" to="/tapoff" @click.prevent="timerOff">||</router-link>
	</div>
	<div class="footer">
		<h2></h2>
	</div>
  
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import moment from 'moment';
import axios from 'axios'
const http = axios.create({
  withCredentials: true,
  crossdomain: true
})
export default {
  name: 'TapRunning',
  props: {
  },
  data () {
	  return {
		timerstarttime:moment.unix(localStorage.getItem('timer-started')).format("h:mm a"),
		timerlength:''
    }
  },
  methods: {
	timerOff: function () {
		localStorage.setItem('timer-ended', moment().format('X'));
	},
	calcTimer: function () {
		var start = moment.unix(localStorage.getItem('timer-started')); //todays date
		var end = moment.unix(moment().format('X')); // another date
		var duration = moment.duration(end.diff(start));
		this.timerlength = '';
		var h = moment.utc(duration.as('milliseconds')).format('HH');
		if (h != '00') 
			this.timerlength += h + ':';
		var m = moment.utc(duration.as('milliseconds')).format((h != '00') ? 'mm':'m');
		if (m != '00')
			this.timerlength += m + ':';
		this.timerlength += moment.utc(duration.as('milliseconds')).format((m != '00') ? 'ss':'s');
	}
  },
  mounted() {
  },
	created: function () {
	  var self = this;	  
		setInterval(function () {
			self.calcTimer();
	  }, 1000);
  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
	.top {
		height:20vh;
		vertical-align: middle;
	}
	.mid {
		height:35vh;
	}
	.bottom {
		height:20vh;
	}
	.footer {
		height:7vh;
	}
.blob {
	display: block;
	padding-top:12%;
	background: white;
	border-radius: 50%;
	margin: 50px auto;
	height: 37vw;
	width: 37vw;
	color:green;
        /* display: table-cell; */
        vertical-align: middle;
	font-size:2rem;
	font-weight:bold;
	text-align: center;
	vertical-align: middle;

	box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
	transform: scale(1);
	animation: pulse 2.5s infinite;
}

@keyframes pulse {
	0% {
		transform: scale(0.85);
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
	}

	100% {
		transform: scale(0.85);
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
	}
}
</style>





